<template>
  <div class="header">
    <h1 class="header-logo" @click="logoPage"></h1>
    <div class="header-right" v-if="titleList.length">
      <TextSwiper :titleList="titleList" />
    </div>
  </div>
</template>
<script>
import TextSwiper from "./textSwiper.vue";
export default {
  name: "PcLogIn",
  components: {
    TextSwiper,
  },
  data: function () {
    return {
      titleList: [],
    };
  },
  methods: {
    // 清除 input 框
    logoPage: function () {
      window.location = document.getElementById("hidReturnUrl").value;
    },
  },
  created() {
    try {
      const _self = this;
      const restImgs = _self.$http.getByThePictureImgs();
      restImgs
        .then((res) => {
          if (Number(res.Code) === 200 && res.Data.Notices.length > 0) {
            _self.titleList = res.Data.Notices;
          } else {
            console.warn(
              `headert 公告 Notices:{Title:[],Href:url}[]:${res.Data.Notices.length}`
            );
          }
        })
        .catch(function (e) {
          console.warn(e);
        });
    } catch (e) {
      console.warn("Cannot read properties of undefined  getByThePictureImgs");
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@css/style.scss";
.header {
  position: relative;
  left: -30px;
  box-sizing: border-box;
  width: 1200px;
  padding-left: 0.44rem;
  height: 67px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-logo {
    width: 400px;
    height: 66px;
    background: #fff url("../assets/img/logo.png") no-repeat 34px center;
    background-size: 277px auto;
    cursor: pointer;
  }
  .header-right {
    height: 67px;
    overflow: hidden;
    position: relative;
    /* max-width: 300px; */
    /* min-width: 600px; */
    display: flex;
    padding-left: 25px;
    background: #fff url("../assets/img/icons/trumpet.png") no-repeat left
      center;
    background-size: 18px 16px;
    font-size: 14px;
    font-weight: 500;
    color: #6e6e6e;
  }
}
</style>
